import { ColumnDef } from '@tanstack/react-table';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

interface TableSkeletonLoaderProps<T = Record<string, unknown>> {
  columns: ColumnDef<T>[];
  selectRow?: boolean;
  expandRow?: boolean;
  rowCount?: number;
}

/** Varying the width per row keeps the placeholder from reading as a rigid grid. */
const CELL_WIDTHS = ['70%', '80%', '90%', '65%'];

const TableSkeletonLoader = <T extends Record<string, unknown>>({
  columns,
  selectRow = false,
  expandRow = false,
  rowCount = 10,
}: TableSkeletonLoaderProps<T>) => (
  <TableContainer>
    <Table aria-busy aria-label='Loading'>
      <TableHead>
        <TableRow>
          {selectRow && (
            <TableCell padding='checkbox'>
              <Skeleton variant='rectangular' width={16} height={16} />
            </TableCell>
          )}
          {columns.map((_column, index) => (
            <TableCell key={`skeleton-header-${index}`}>
              <Skeleton variant='text' width='60%' height={18} />
            </TableCell>
          ))}
          {expandRow && (
            <TableCell padding='checkbox'>
              <Skeleton variant='rectangular' width={20} height={16} />
            </TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: rowCount }, (_row, rowIndex) => (
          <TableRow key={`skeleton-${rowIndex}`}>
            {selectRow && (
              <TableCell padding='checkbox'>
                <Skeleton variant='rectangular' width={16} height={16} />
              </TableCell>
            )}
            {columns.map((_column, colIndex) => (
              <TableCell key={`skeleton-cell-${rowIndex}-${colIndex}`}>
                <Skeleton variant='text' width={CELL_WIDTHS[rowIndex % CELL_WIDTHS.length]} height={16} />
              </TableCell>
            ))}
            {expandRow && (
              <TableCell padding='checkbox'>
                <Skeleton variant='rectangular' width={20} height={16} />
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TableSkeletonLoader;
